import type {FC} from 'react'
import type React from 'react'

import {theme} from '@product-web/styles/theme'

interface PleoLogoHorizontalProps extends React.SVGProps<SVGSVGElement> {
    testId?: string
}

export const PleoLogoHorizontal: FC<PleoLogoHorizontalProps> = ({
    testId,
    width,
    height,
    fill,
    ...props
}) => {
    return (
        <svg
            viewBox="0 0 72 27"
            xmlns="http://www.w3.org/2000/svg"
            data-testid={testId}
            width={width}
            height={height}
            fill={fill}
            data-generic-ui="logo-pleo"
            {...props}
        >
            <path
                d="M12.64 11.7997C12.64 12.6383 12.3071 13.4427 11.7143 14.036C11.1216 14.6293 10.3176 14.9631 9.47894 14.9639H4.33688V8.64181H9.47894C10.318 8.64181 11.1226 8.97504 11.716 9.56822C12.3094 10.1614 12.6429 10.966 12.6432 11.805L12.64 11.7997ZM17.1547 11.8274V11.8188C17.1545 9.83064 16.3645 7.92394 14.9586 6.51807C13.5528 5.11219 11.6461 4.32225 9.65786 4.32197H0V25.6229H4.33901V19.3179H9.6568C11.6438 19.3162 13.5489 18.5257 14.9534 17.1202C16.3579 15.7147 17.147 13.809 17.1473 11.822L17.1547 11.8274ZM33.4234 25.6166H49.0892V21.2978H37.7432V18.9334C39.7125 18.3593 41.7276 17.4423 43.7511 16.1781L45.5841 15.0321L43.2889 11.3577L41.4517 12.5047C40.2776 13.2493 39.0342 13.8785 37.7389 14.3835V8.64181H49.0892V4.31664H33.4234V15.3133C31.3167 15.3868 29.6595 14.834 28.4326 14.147C25.9691 12.7678 23.0317 9.56734 23.0285 2.16631V0H18.6959V2.16631C18.6959 9.68662 21.334 15.1365 26.3163 17.929C28.3582 19.0691 30.6609 19.6603 32.9995 19.6448C33.1401 19.6448 33.2817 19.6395 33.4255 19.6363L33.4234 25.6166ZM67.7179 15.0055C67.7262 15.9221 67.5852 16.834 67.3004 17.7054C67.0474 18.4929 66.6405 19.2224 66.1033 19.8514C65.5842 20.45 64.9428 20.9305 64.2225 21.2605C63.4447 21.6086 62.6003 21.7823 61.7483 21.7696C60.8937 21.7816 60.0467 21.6079 59.2657 21.2605C58.5412 20.9324 57.896 20.4518 57.3742 19.8514C56.8367 19.2224 56.4295 18.493 56.176 17.7054C55.6207 15.9483 55.6207 14.0627 56.176 12.3056C56.4309 11.516 56.8379 10.784 57.3742 10.151C57.8935 9.54589 58.5392 9.06201 59.2657 8.7334C60.0465 8.38556 60.8937 8.21184 61.7483 8.22431C62.6004 8.21103 63.4449 8.38481 64.2225 8.7334C64.9459 9.06356 65.5889 9.54729 66.1065 10.151C66.6413 10.7844 67.0469 11.5163 67.3004 12.3056C67.585 13.177 67.726 14.0888 67.7179 15.0055ZM71.9994 15.0119C72.0132 13.5072 71.7712 12.0112 71.2837 10.5877C70.8413 9.28556 70.1424 8.08539 69.2282 7.05808C68.329 6.06154 67.2268 5.26912 65.9958 4.73414C64.7347 4.17819 63.3196 3.90021 61.7505 3.90021C60.1813 3.90021 58.7612 4.17819 57.4903 4.73414C56.2529 5.26613 55.1449 6.05881 54.2419 7.05808C53.3281 8.08548 52.6295 9.28565 52.1874 10.5877C51.2331 13.4596 51.2331 16.5631 52.1874 19.435C52.6272 20.7336 53.3262 21.9293 54.2419 22.9497C55.1491 23.941 56.2572 24.7275 57.4924 25.2566C58.7634 25.8118 60.1834 26.0898 61.7526 26.0905C63.3218 26.0912 64.7365 25.8132 65.9968 25.2566C67.2245 24.7244 68.3257 23.9386 69.2282 22.9507C70.1439 21.9304 70.8428 20.7346 71.2827 19.4361C71.77 18.0125 72.0116 16.5165 71.9973 15.0119"
                fill="black"
            />
        </svg>
    )
}

PleoLogoHorizontal.defaultProps = {
    width: 72,
    height: 27,
    fill: theme.colors.shade900,
}
